import Alpine from 'alpinejs';
window.Alpine = Alpine;

document.addEventListener('alpine:init', () => {
    Alpine.data('headerMenu', () => ({
        careHomesMenuOpen: false,
        mobileMenuOpen: false,

        checkIfMobileMenuNeedsClosing() {
            if (this.mobileMenuOpen) {
                this.mobileMenuOpen = window.innerWidth < 1024
            }
        }
    }));

    Alpine.data('reviewsCarousel', () => ({
        slides: [],
        activeSlide: null
    }));

    Alpine.data('accordion', () => ({
        state: false,

        toggleState() {
            this.state = !this.state;
        }
    }));

    Alpine.data('payment', () => ({
        step: 1,

        // Step 1
        paymentType: '',
        productId: 0,
        buttonOneLoading: false,
        buttonTwoLoading: false,

        // Step 2
        careHome: '',
        branchName: '',
        name: '',
        accountNumber: '',
        amount: '',
        buttonPaymentLoading: false,

        // Buttons
        redirectionButtonVisible: false,

        // Modal
        open: false,

        // Generic
        errors: [],
        success: false,

        // Lists
        careHomeNames: [],
        homeCareBranches: [],

        minAmountValue: 10.50,
        maxAmountValue: 10000,

        sandboxMode: false,

        init() {
            if (this.sandboxMode) {
                this.step = 2;
                this.productId = 377;
                this.paymentType = 'hch';
            }

            this.careHomeNames = window.careHomeNames;
            this.homeCareBranches = window.homeCareBranches;
        },

        completeStepOne(type) {
            this.buttonOneLoading = false;
            this.buttonTwoLoading = false;

            if (type === 'hch') {
                this.productId = 377;
                this.buttonOneLoading = true;
            }
            else if (type === 'mhc') {
                this.productId = 403;
                this.buttonTwoLoading = true;
            }

            this.paymentType = type;

            setTimeout(() => {
                this.step = 2;
            }, 500)
        },

        completeStepTwo() {
            let ref = this;

            this.errors = [];
            this.buttonPaymentLoading = true;

            this.validateField('careHome');
            this.validateField('name');
            this.validateField('accountNumber');
            this.validateField('amount');

            if (this.errors.length > 0) {
                this.buttonPaymentLoading = false;
                return;
            }

            let name = '';
            if (this.paymentType === 'hch')
                name = this.careHome;
            else if (this.paymentType === 'mhc')
                name = this.branchName;

            fetch(hch_theme_ajax_endpoint, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded; charset=utf-8'
                },
                body: 'action=hch_submit_payment_form&care_home=' + this.careHome +'&name=' + this.name +'&reference=' + this.accountNumber +'&amount=' + this.amount + '&product_id=' + this.productId
            })
                .then((response) => {
                    if (!response.ok) {
                        throw Error(response.statusText);
                    }
                    return response;
                })
                .then((response) => response.json())
                .then((data) => {
                    ref.buttonPaymentLoading = true;
                    ref.open = true;

                    setTimeout(() => {
                        ref.redirectionButtonVisible = true;
                    }, 350)

                    setTimeout(() => {
                        window.location = '/checkout/';
                    }, 650)
                })
                .catch((error) => {
                    console.error(error);
                });
        },

        goToStep(step) {
            this.errors = [];
            this.step = step;
            this.buttonOneLoading = false;
            this.buttonTwoLoading = false;
            this.buttonPaymentLoading = false;
        },

        /**
         * Check if the errors array contains this field.
         *
         * @param field
         * @returns {*}
         */
        hasError(field) {
            return this.errors.find(x => x.field === field);
        },

        /**
         * Fetch the error text for this message.
         *
         * @param field
         * @returns {string|*}
         */
        getErrorText(field) {
            if (this.hasError(field))
                return this.errors.find(x => x.field === field).message;

            return '';
        },

        validateField(field) {
            if (this.paymentType === 'hch') {
                if (field === 'careHome') {
                    if (this.careHome.length === 0) {
                        this.errors.push({
                            'field': field,
                            'message': 'Please select an option.'
                        });

                        return;
                    }
                }
            }

            if (this.paymentType === 'mhc') {
                if (field === 'branchName') {
                    if (this.branchName.length === 0) {
                        this.errors.push({
                            'field': field,
                            'message': 'Please select an option.'
                        });

                        return;
                    }
                }
            }

            if (field === 'name') {
                if (this.name.length === 0) {
                    this.errors.push({
                        'field': field,
                        'message': 'Please enter the name shown on your invoice.'
                    });

                    return;
                }
            }

            if (field === 'accountNumber') {
                if (this.accountNumber.length === 0) {
                    this.errors.push({
                        'field': field,
                        'message': 'Please enter a value.'
                    });

                    return;
                }
            }

            if (field === 'amount') {
                if (this.amount.length === 0) {
                    this.errors.push({
                        'field': field,
                        'message': 'Please enter a value.'
                    });

                    return;
                }

                let amount = Number(this.amount);

                if (amount < 10.50) {
                    this.errors.push({
                        'field': field,
                        'message': 'The minimum payment amount is Â£10.50'
                    });

                    return;
                }

                if (amount > 10000) {
                    this.errors.push({
                        'field': field,
                        'message': 'The maximum payment amount is Â£10,000'
                    });

                    return;
                }
            }
        }
    }));

    Alpine.data('carehomeSearch', () => ({
        viewType: 'list',

        loading: true,

        results: [],
        visibleResults: [],
        hiddenResults: [],

        // Search Specific
        location: '',
        careService: -1,

        // Google Map Specific
        locations: [],

        // Dropdown
        open: false,
        activeIndex: null,

        sortType: 0,
        selected: null,

        init() {
            let ref = this;

            this.loading = true;

            this.location = (new URLSearchParams(window.location.search).get('location') || '');
            this.careService = (new URLSearchParams(window.location.search).get('service') || -1);

            fetch(hch_theme_ajax_endpoint, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded; charset=utf-8'
                },
                body: 'action=hch_fetch_carehomes&postcode=' + this.location + '&term_id=' + this.careService
            })
                .then((response) => {
                    if (!response.ok) {
                        throw Error(response.statusText);
                    }
                    return response;
                })
                .then((response) => response.json())
                .then((data) => {
                    data.data.results.forEach(function (post, index) {
                        ref.results.push({
                            id: post.id,
                            title: post.title,
                            permalink: post.permalink,
                            image: post.image,
                            image_alt: post.image_alt,
                            address: post.address,
                            telephone_one: post.telephone_one,
                            telephone_two: post.telephone_two,
                            featured_image_badge_enabled: post.featured_image_badge_enabled,
                            featured_image_badge_text: post.featured_image_badge_text,
                            latitude: post.latitude,
                            longitude: post.longitude,
                            distance: post.distance,
                            google_distance: post.google_distance,
                            google_duration: post.google_duration,
                            tags: post.tags
                        });

                        ref.locations.push({
                            id: post.id,
                            title: post.title,
                            latitude: post.latitude,
                            longitude: post.longitude,
                        })
                    });

                    // store these results as the hidden results
                    this.hiddenResults = [];
                    this.visibleResults = this.visibleResults.concat(this.results);

                    this.loading = false;
                    google.maps.event.addDomListener(window, 'load', this.initMap());
                })
                .catch((error) => {
                    console.error(error);
                });
        },

        sort(sortType) {
            let ref = this;

            this.loading = true;
            this.sortType = sortType;
            this.hiddenResults = [];
            this.visibleResults = [];
            this.locations = [];

            this.hiddenResults =  this.hiddenResults.concat(this.results);

            if (sortType === 3) {
                this.hiddenResults.sort((a, b) => a.google_distance - b.google_distance)
            } else if (sortType === 4) {
                this.hiddenResults.sort((a, b) => a.google_duration - b.google_duration)
            }

            // take 9 hidden results
            const r = this.hiddenResults.slice(0, 9);

            r.forEach(function (post) {
                ref.visibleResults.push({
                    id: post.id,
                    title: post.title,
                    permalink: post.permalink,
                    image: post.image,
                    image_alt: post.image_alt,
                    address: post.address,
                    telephone_one: post.telephone_one,
                    telephone_two: post.telephone_two,
                    featured_image_badge_enabled: post.featured_image_badge_enabled,
                    featured_image_badge_text: post.featured_image_badge_text,
                    latitude: post.latitude,
                    longitude: post.longitude,
                    distance: post.distance,
                    google_distance: post.google_distance,
                    google_duration: post.google_duration,
                    tags: post.tags
                })

                ref.locations.push({
                    id: post.id,
                    title: post.title,
                    latitude: post.latitude,
                    longitude: post.longitude,
                });
            });

            this.hiddenResults.splice(0, 9);
            this.loading = false;

            if (this.viewType === 'list')
                this.initMap()
        },

        search() {
            let ref = this;

            this.loading = true;

            this.results = [];
            this.hiddenResults = [];
            this.visibleResults = [];
            this.locations = [];

            fetch(hch_theme_ajax_endpoint, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded; charset=utf-8'
                },
                body: 'action=hch_fetch_carehomes&postcode=' + this.location + '&term_id=' + this.careService
            })
                .then((response) => {
                    if (!response.ok) {
                        throw Error(response.statusText);
                    }
                    return response;
                })
                .then((response) => response.json())
                .then((data) => {
                    data.data.results.forEach(function (post, index) {
                        ref.results.push({
                            id: post.id,
                            title: post.title,
                            permalink: post.permalink,
                            image: post.image,
                            image_alt: post.image_alt,
                            address: post.address,
                            telephone_one: post.telephone_one,
                            telephone_two: post.telephone_two,
                            featured_image_badge_enabled: post.featured_image_badge_enabled,
                            featured_image_badge_text: post.featured_image_badge_text,
                            latitude: post.latitude,
                            longitude: post.longitude,
                            distance: post.distance,
                            google_distance: post.google_distance,
                            google_duration: post.google_duration,
                            tags: post.tags
                        })
                    });

                    // store these results as the hidden results
                    this.hiddenResults = this.hiddenResults.concat(this.results);

                    // take 9 hidden results
                    const r = this.hiddenResults.slice(0, 9);

                    r.forEach(function (post, index) {
                        ref.visibleResults.push({
                            id: post.id,
                            title: post.title,
                            permalink: post.permalink,
                            image: post.image,
                            image_alt: post.image_alt,
                            address: post.address,
                            telephone_one: post.telephone_one,
                            telephone_two: post.telephone_two,
                            featured_image_badge_enabled: post.featured_image_badge_enabled,
                            featured_image_badge_text: post.featured_image_badge_text,
                            latitude: post.latitude,
                            longitude: post.longitude,
                            distance: post.distance,
                            google_distance: post.google_distance,
                            google_duration: post.google_duration,
                            tags: post.tags
                        })

                        ref.locations.push({
                            id: post.id,
                            title: post.title,
                            latitude: post.latitude,
                            longitude: post.longitude,
                        })
                    });

                    this.hiddenResults.splice(0, 9);

                    this.loading = false;
                    this.initMap();
                })
                .catch((error) => {
                    console.error(error);
                });
        },

        loadMore() {
            this.loading = true;

            let ref = this;

            if (this.sortType === 3) {
                this.hiddenResults.sort((a, b) => a.google_distance - b.google_distance)
            } else if (this.sortType === 4) {
                this.hiddenResults.sort((a, b) => a.google_duration - b.google_duration)
            }

            const r = this.hiddenResults.slice(0, 5);

            r.forEach(function (post) {
                ref.visibleResults.push({
                    id: post.id,
                    title: post.title,
                    permalink: post.permalink,
                    image: post.image,
                    image_alt: post.image_alt,
                    address: post.address,
                    telephone_one: post.telephone_one,
                    telephone_two: post.telephone_two,
                    featured_image_badge_enabled: post.featured_image_badge_enabled,
                    featured_image_badge_text: post.featured_image_badge_text,
                    latitude: post.latitude,
                    longitude: post.longitude,
                    distance: post.distance,
                    google_distance: post.google_distance,
                    google_duration: post.google_duration,
                    tags: post.tags
                })

                ref.locations.push({
                    id: post.id,
                    title: post.title,
                    latitude: post.latitude,
                    longitude: post.longitude,
                })
            });

            this.hiddenResults.splice(0, 5);

            this.loading = false;
            this.initMap()
        },

        initMap() {
            this.loading = false;

            const map = new google.maps.Map(document.getElementById('map'), {
                zoom: 10,
                center: {
                    lat: 51.900673080073005,
                    lng: -0.6368104249999984
                }
            });

            let infoWindow = null;

            let latlngbounds = new google.maps.LatLngBounds();

            let ref = this;

            this.locations.forEach(function (location, index) {
                infoWindow = new google.maps.InfoWindow();

                let marker = new google.maps.Marker({
                    map,
                    position: {
                        lat: Number(location.latitude),
                        lng: Number(location.longitude)
                    },
                    title: location.title,
                    label: {
                        text: (index + 1).toString(),
                        color: 'white'
                    },
                    icon: '/wp-content/themes/healthcarehomes/assets/images/search/pin-01.png',
                    careHomeId: location.id
                });

                latlngbounds.extend(marker.position);

                marker.addListener('click', () => {
                    infoWindow.close();
                    infoWindow.setContent(marker.getTitle());
                    infoWindow.open(marker.getMap(), marker);

                    ref.selected = marker.careHomeId;

                    document.getElementById('care-home-' + marker.careHomeId).scrollIntoView({
                        behavior: 'smooth'
                    });
                });
            });

            // Get the boundaries of the Map.
            let bounds = new google.maps.LatLngBounds();

            // Center map and adjust Zoom based on the position of all markers.
            map.setCenter(latlngbounds.getCenter());
            map.fitBounds(latlngbounds);
        },

        changeView(type) {
            this.viewType = type;
        }
    }));

    Alpine.data('faqs', () => ({
        activeCategory: 0,
        categories: [],
        topics: [],
        activeTopics: [],

        init() {
            let ref = this;

            fetch(hch_theme_ajax_endpoint, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded; charset=utf-8'
                },
                body: 'action=hch_init_faqs',
            })
                .then((response) => {
                    if (!response.ok) {
                        throw Error(response.statusText);
                    }
                    return response;
                })
                .then((response) => response.json())
                .then((data) => {
                    if (data.data.categories.length > 0 && Array.isArray(data.data.categories)) {
                        data.data.categories.forEach(function (post, index) {
                            ref.categories.push({
                                id: post.term_id,
                                name: post.name
                            })
                        });
                    }

                    data.data.results.forEach(function (post, index) {
                        ref.topics.push({
                            id: post.id,
                            title: post.title,
                            content: post.content,
                            category: parseInt(post.category),
                            state: post.state
                        })
                    });

                    if (ref.categories.length > 0) {
                        ref.activeCategory = ref.categories[0].id;
                    }

                    ref.activeTopics = this.topics.filter(x => x.category === this.activeCategory);
                })
                .catch((error) => {
                    console.error(error);
                });
        },

        changeCategory(id) {
            this.activeCategory = id;
            this.activeTopics = [];

            let ref = this;

            fetch(hch_theme_ajax_endpoint, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded; charset=utf-8'
                },
                body: 'action=hch_fetch_faq_topics&term_id=' + id,
            })
                .then((response) => {
                    if (!response.ok) {
                        throw Error(response.statusText);
                    }
                    return response;
                })
                .then((response) => response.json())
                .then((data) => {
                    ref.topics = [];

                    data.data.results.forEach(function (post, index) {
                        ref.topics.push({
                            id: post.id,
                            title: post.title,
                            content: post.content,
                            category: parseInt(post.category),
                            state: post.state
                        })
                    });

                    ref.activeTopics = this.topics.filter(x => x.category === this.activeCategory);
                })
                .catch((error) => {
                    console.error(error);
                });
        }
    }));

    Alpine.data('homeCareTeamCarousel', () => ({
        slides: [],
        visibleSlides: [],
        activeSlide: null,
        layout: 'grid',

        currentPage: 0,
        pagedSlides: [],

        update() {
            this.pages = Math.ceil(this.slides.length / 4);

            this.pagedSlides = this.chunk(this.slides, 4);
            this.visibleSlides = this.pagedSlides[0];
        },

        getNextSlide() {
            let index = this.slides.indexOf(this.activeSlide);
            if(index >= 0 && index <  this.slides.length - 1) {
                this.activeSlide = this.slides[index + 1]
                this.activeSlide.visible = true;
            } else {
                this.activeSlide = this.slides[0]
                this.activeSlide.visible = true;
            }
        },

        getPreviousSlide() {
            let index = this.slides.indexOf(this.activeSlide);
            if(index >= 1 && index < this.slides.length + 1) {
                this.activeSlide = this.slides[index - 1]
                this.activeSlide.visible = true;
            }
        },

        nextPage() {
            this.currentPage++;
            if (this.pagedSlides[this.currentPage] === undefined) {
                this.currentPage = 0;
                this.visibleSlides = this.pagedSlides[0];
            }
            else
                this.visibleSlides = this.pagedSlides[this.currentPage];
        },

        previousPage() {
            if (this.currentPage === 0)
                return;

            this.currentPage--;
            this.visibleSlides = this.pagedSlides[this.currentPage];
        },

        chunk (arr, len) {
            let chunks = [],
                i = 0,
                n = arr.length;

            while (i < n) {
                chunks.push(arr.slice(i, i += len));
            }

            return chunks;
        }
    }));

    Alpine.data('carehomeAccommodationCarousel', () => ({
        slides: [],
        activeSlide: null,

        getNext() {
            let index = this.slides.indexOf(this.activeSlide);
            if(index >= 0 && index <  this.slides.length - 1) {
                this.activeSlide = this.slides[index + 1]
                this.activeSlide.visible = true;
            } else {
                this.activeSlide = this.slides[0]
                this.activeSlide.visible = true;
            }
        },

        getPrevious() {
            let index = this.slides.indexOf(this.activeSlide);
            if(index >= 1 && index < this.slides.length + 1) {
                this.activeSlide = this.slides[index - 1]
                this.activeSlide.visible = true;
            }
        }
    }));

    Alpine.data('careHomeManagementBlock', () => ({
        slides: [],
        activeSlide: null,

        getNext() {
            let index = this.slides.indexOf(this.activeSlide);
            if(index >= 0 && index <  this.slides.length - 1) {
                this.activeSlide = this.slides[index + 1]
                this.activeSlide.visible = true;
            } else {
                this.activeSlide = this.slides[0]
                this.activeSlide.visible = true;
            }
        },

        getPrevious() {
            let index = this.slides.indexOf(this.activeSlide);
            if(index >= 1 && index < this.slides.length + 1) {
                this.activeSlide = this.slides[index - 1]
                this.activeSlide.visible = true;
            }
        }
    }));
});


Alpine.start();

document
    .querySelectorAll('a[href^="#"]')
    .forEach(trigger => {
        trigger.onclick = function (e) {
            e.preventDefault();
            let hash = this.getAttribute('href');
            let target = document.querySelector(hash);
            let headerOffset = getElementHeight('#header');
            let elementPosition = target.offsetTop;
            let offsetPosition = elementPosition - headerOffset;

            console.log(elementPosition);
            console.log(headerOffset);

            if (hash === '#overview')
                offsetPosition = 0;

            window.scrollTo({
                top: offsetPosition,
                behavior: "smooth"
            });
        };
    });

function getElementHeight(el) {
    return document.querySelector(el).offsetHeight
}